export const getSafeProfileString = (value?: string | null) => value?.trim() ?? ""
